import type { AdditionalLanguage } from "@/Modules/Models/Domain/Therapist";
import type { TherapistUpdateAdditionalLanguagesApiQuery } from "@/Modules/Models/Api/Therapist";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { updateAdditionalLanguages } from "@/Services/TherapyApi/TherapistsFunctional";

import useTherapistStore from "@/Modules/Therapist/Store";

import camelize from "@/Utils/Camelize";

async function updateAdditionalLanguagesAH(languages: AdditionalLanguage[]) {
  const therapistStore = useTherapistStore();

  try {
    therapistStore.isLoading = true;

    const therapistUpdateAdditionalLanguagesApiQuery: TherapistUpdateAdditionalLanguagesApiQuery[] =
      transformTherapistLanguagesToApiQuery(languages);

    await updateAdditionalLanguages(therapistUpdateAdditionalLanguagesApiQuery);

    if (therapistStore.therapist?.additionalLanguages) {
      const updatedLanguageUuids = languages.map((language) => language.uuid);
      const updatedLanguages = therapistStore.therapist.additionalLanguages.map((language) => {
        return updatedLanguageUuids.includes(language.uuid)
          ? { ...language, isActive: !language.isActive }
          : language;
      });

      therapistStore.therapist.additionalLanguages = updatedLanguages;
      therapistStore.notification = {
        type: NotificationType.SUCCESS,
        code: null,
        message: "",
      };
    }
  } catch (error: unknown) {
    therapistStore.notification = {
      type: NotificationType.ERROR,
      code: null,
      message: "settings.configuration.additional_languages.notification.error",
    };
  } finally {
    therapistStore.isLoading = false;
  }
}

function transformTherapistLanguagesToApiQuery(
  languages: AdditionalLanguage[]
): TherapistUpdateAdditionalLanguagesApiQuery[] {
  return languages.map((language) => {
    return camelize<AdditionalLanguage, TherapistUpdateAdditionalLanguagesApiQuery>(
      language,
      ["uuid", "isActive"],
      ["uuid", "is_active"]
    ) as TherapistUpdateAdditionalLanguagesApiQuery;
  });
}

export default updateAdditionalLanguagesAH;
